import { render, staticRenderFns } from "./sendType.vue?vue&type=template&id=4c1f75c7&scoped=true&"
import script from "./sendType.vue?vue&type=script&lang=js&"
export * from "./sendType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1f75c7",
  null
  
)

export default component.exports